import * as Actions from './actions';

export function customerQuotationReducer(state = null, action) {
  switch (action.type) {
    case Actions.CUSTOMER_QUOTATION_RETRIEVED:
      return action.customerQuotation;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/DataServices/CustomerQuotationService/reducers.js